module.exports = __webpack_public_path__ + "static/img/yyzz.e115c31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yyzz.jpg
// module id = 1425
// module chunks = 1